export default "__VITE_ASSET__Cg7HF3FI__"